<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';

import { useWebMcpUnitsSearchTool } from '@/composables/useWebMcpUnitsSearchTool';
import { ListingTypeEnum } from '@/enums/ListingType';

const isRentalPath = window.location.pathname.includes('/rental') || window.location.pathname.includes('/location');
const defaultListingTypes = isRentalPath
  ? [ListingTypeEnum.Rental]
  : [ListingTypeEnum.Sale, ListingTypeEnum.Rental];

const { register, unregister } = useWebMcpUnitsSearchTool({
  listingTypes: defaultListingTypes
});

onMounted(() => {
  register();
});

onUnmounted(() => {
  unregister();
});
</script>

<template>
  <div aria-hidden="true"
       style="display:none;"></div>
</template>
